import { FC, useMemo } from 'react';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { Heading } from 'src/components/common/Heading';
import { ProductDTO } from 'src/models/pim';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { useProductAttributes } from 'src/modules/products/hooks/useProductAttributes';
import styled from 'styled-components';
import { ProductPageDownloadsItem } from './ProductPageDownloadsItem';
import { media } from 'src/styles/designs';
import { Paragraph } from 'src/components/common/typography/Text';
import { useTitlesDictionary } from 'src/modules/products/hooks/useTitlesDictionary';
import { DictionaryTitlesCode } from 'src/models/pim/dictionaries';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

const Section = styled.section`
  padding: 50px 0 56px;
  background: ${({ theme }) => theme.palette.background};

  ${media.w.greaterThanOrEqual.desktop} {
    padding: 80px 0 160px;
  }
`;

export const ProductPageDownloads: FC<ProductDTO> = (product) => {
  const [title] = useTitlesDictionary(DictionaryTitlesCode.Downloads);
  const [subtitle] = useTitlesDictionary(
    DictionaryTitlesCode.DownloadsSubtitle,
  );

  const { getProductAttribute } = useProductAttributes(product.attributes);

  const files = useMemo(
    () =>
      getProductAttribute(ProductAttributeCode.Leaflet)?.map(
        (attribute) => attribute.directus_files_id,
      ) ?? [],
    [getProductAttribute],
  );

  if (files.length === 0) {
    return null;
  }

  return (
    <Section>
      <ConstraintContainer>
        {title && (
          <Heading>
            <Markdown>{title.value}</Markdown>

            {subtitle && (
              <Paragraph>
                <Markdown>{subtitle.value}</Markdown>
              </Paragraph>
            )}
          </Heading>
        )}

        <ul>
          {files.map((file) => (
            <ProductPageDownloadsItem key={file.id} {...file} />
          ))}
        </ul>
      </ConstraintContainer>
    </Section>
  );
};
